// packages
import { geoIdentity, GeoIdentityTransform } from 'd3-geo';
import { Component, h } from 'preact';

// components
import Contest from './Contest';
import CountyTable from './CountyTable';
import HeadshotCandidateRow from './HeadshotCandidateRow';
import SeatPartyDivider from './SeatPartyDivider';
import LayeredMap from './LayeredMap';
import Portal from './Portal';

// utils
import { isThisIE } from '../utils/platform';
import { determineContestTitle, presidentCandidateColors, senateCandidateColors } from '../election-utils';
import { DEMOCRAT, NEUTRAL, OTHER } from '../colors';
import { SHOW_DELEGATES } from '../constants'

import topology from 'Assets/geography/texas_urban.json';

const isIE = isThisIE();

interface ContestShowcaseProps {
  container: Element;
  contest: any | null;
}

interface ContestShowcaseState {
  contestContainer: Element;
  mapContainer: Element;
  countiesContainer: Element;
}

class ContestShowcase extends Component<
  ContestShowcaseProps,
  ContestShowcaseState
> {
  projection: GeoIdentityTransform;

  constructor() {
    super();

    this.projection = geoIdentity().reflectY(true);
  }

  componentDidMount() {
    const { container } = this.props;

    

    const contestContainer = container.querySelector('.contest-container');
    const mapContainer = container.querySelector('.contest-map-container');
    const countiesContainer = container.querySelector(
      '.contest-counties-container'
    );

    this.setState({ contestContainer, mapContainer, countiesContainer });
  }

  render() {
    const { contest, delegates } = this.props;
    const { contestContainer, mapContainer, countiesContainer } = this.state;

    const shouldDisplay5Candidates =
      contest && contest.office == 'President' && contest.party == 'Democrat';

    const visibleCandidates = shouldDisplay5Candidates ? 6 : 3;

    const headerUsed = shouldDisplay5Candidates && SHOW_DELEGATES == true ? HeadshotCandidateRow.Header_Prez : HeadshotCandidateRow.Header;


    let candidatesRender;

    if (contest) {
      let candidates = contest.candidacies;
      candidatesRender = shouldDisplay5Candidates ? presidentCandidateColors : senateCandidateColors;

    
    }


    if (!contest) return null;

    return (
      <span>
        {contestContainer && (
          <Portal
            node={contestContainer}
            ref={ref => (this._contestPortal = ref)}
          >
            <Contest
              contest={contest}
              contestTitle={determineContestTitle(contest)}
              isShowcaseRace
              renderParty={party => (
                <SeatPartyDivider
                  partyName={party.party}
                  partyBallot={party}
                  isShowcaseRace
                  tableHeader={headerUsed}
                  columnCount={HeadshotCandidateRow.columnCount}
                  renderCandidate={(
                    candidate: any,
                    idx: number,
                    candidatesRender: any,
                    viewAllCandidates: any,
                    { totalVotes }: { totalVotes: number }
                  ) => (
                    <HeadshotCandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      contestIsCalled={contest.is_called}
                      delegate_num={delegates}
                      isIncumbent={candidate.is_incumbent}
                      isWinner={candidate.is_winner}
                      isViewable={viewAllCandidates || idx < visibleCandidates}
                      party={candidate.party}
                      candidateColors={candidatesRender}
                      totalVotesInContest={totalVotes}
                      votes={candidate.votes}
                    />
                  )}
                />
              )}
            />
          </Portal>
        )}
        {!isIE && mapContainer && (
          <Portal node={mapContainer} ref={ref => (this._mapPortal = ref)}>
            <LayeredMap
              topology={topology}
              projection={this.projection}
              candidates={contest.candidacies}
              candidatesRender={candidatesRender}
              counties={contest.counties}
              precinctsReporting={contest.precincts_reporting}
              totalVotes={contest.total_votes}
            />
          </Portal>
        )}
        {/* {!isIE &&
          countiesContainer && (
            <Portal
              node={countiesContainer}
              ref={ref => (this._countiesPortal = ref)}
            >
              <CountyTable
                candidates={contest.candidates}
                counties={contest.counties}
              />
            </Portal>
          )} */}
      </span>
    );
  }
}

export default ContestShowcase;